module.exports = __webpack_public_path__ + "static/media/reactlogo.c52b75e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactlogo.png
// module id = 550
// module chunks = 0